import * as React from 'react'
import * as ReactModal from 'react-modal'

import LoginForm from './LoginForm'
import SignUpForm from './SignUpForm'

// XXX: hack, somehow react modal imported in storybook is exported as default
const ReactModalComponent = (ReactModal as any).default
  ? (ReactModal as any).default
  : ReactModal

const style: React.CSSProperties = {
  height: 50,
  zIndex: 10000,
  backgroundColor: 'black'
}

export interface Props {
  username?: string
  loginLoading: boolean
  loginModal: boolean
  loginErrors: { [index: string]: Array<string> }
  onLoginClick?: () => void
  onLoginClose?: () => void
  onLoginSubmit?: (usernameOrEmail: string, password: string) => void
  signUpLoading: boolean
  signUpModal: boolean
  signUpErrors: { [index: string]: Array<string> }
  onSignUpClick?: () => void
  onSignUpClose?: () => void
  onSignUpSubmit?: (username: string, email: string, password: string) => void
}

export default class Header extends React.Component<Props> {
  render () {
    const {
      username,
      signUpErrors,
      signUpLoading,
      signUpModal,
      loginLoading,
      loginModal,
      loginErrors
    } = this.props
    const contentStyle: React.CSSProperties = {
      position: 'absolute',
      left: '50%',
      top: '50%',
      right: 'initial',
      bottom: 'initial',
      transform: 'translate(-50%, -50%)',
      padding: '1.8rem'
    }
    return (
      <div style={style} className='absolute left-0 top-0 right-0'>
        <div
          className='mx-auto flex items-center justify-between'
          style={{ maxWidth: '1000px' }}>
          <a
            href='https://tipwander.com'
            className='white flex items-center ml2'
            style={{
              height: '50px',
              fontFamily: 'Roboto, sans-serif',
              textDecorationLine: 'none'
            }}
            target='_blank'>
            <img
              className='mr1'
              src='/images/icon@2x.png'
              style={{ width: '32px', height: '32px' }}
            />
            TipWander
          </a>
          {username ? (
            <div
              className='white flex items-center mr2'
              style={{ height: '100%' }}>
              Logged in as {username}
            </div>
          ) : (
            <div className='flex items-center mr2' style={{ height: '100%' }}>
              <button
                className='btn btn-outline bg-white'
                onClick={this._onLoginClick}>
                Login
              </button>
              <button className='btn btn-primary' onClick={this._onSignUpClick}>
                Sign up
              </button>
            </div>
          )}
          <ReactModalComponent
            isOpen={signUpModal}
            contentLabel='sign-up'
            onRequestClose={this._onSignUpModalClose}
            style={{ overlay: { zIndex: 20000 }, content: contentStyle }}>
            <SignUpForm
              onSubmit={this._onSignUpSubmit}
              errors={signUpErrors}
              loading={signUpLoading}
            />
          </ReactModalComponent>
          <ReactModalComponent
            isOpen={loginModal}
            contentLabel='login'
            onRequestClose={this._onLoginModalClose}
            style={{ overlay: { zIndex: 20000 }, content: contentStyle }}>
            <LoginForm
              onSubmit={this._onLoginSubmit}
              errors={loginErrors}
              loading={loginLoading}
            />
          </ReactModalComponent>
        </div>
      </div>
    )
  }

  private _onSignUpClick = () => {
    if (this.props.onSignUpClick) {
      this.props.onSignUpClick()
    }
  }

  private _onSignUpModalClose = () => {
    if (this.props.onSignUpClose) {
      this.props.onSignUpClose()
    }
  }

  private _onSignUpSubmit = (
    username: string,
    email: string,
    password: string
  ) => {
    if (this.props.onSignUpSubmit) {
      this.props.onSignUpSubmit(username, email, password)
    }
  }

  private _onLoginClick = () => {
    if (this.props.onLoginClick) {
      this.props.onLoginClick()
    }
  }

  private _onLoginModalClose = () => {
    if (this.props.onLoginClose) {
      this.props.onLoginClose()
    }
  }

  private _onLoginSubmit = (usernameOrEmail: string, password: string) => {
    if (this.props.onLoginSubmit) {
      this.props.onLoginSubmit(usernameOrEmail, password)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Header.tsx